import axios from "axios";

const state = {
  routeName:false
};

const getters = {
  getRouteName(state){
    return state.routeName;
  }
};

const mutations = {
  SetRouteName(state, payload) {
    state.routeName = payload;
  },
};

const actions = {
    
    BuyAirTime({commit}, payload) {
        let phoneNumber = payload.phoneNumber;
        if (phoneNumber.split("")[0] != "+") {
          while (phoneNumber.charAt(0) === "0") {
            phoneNumber = `+234${phoneNumber.substr(1)}`;
          }
        }
    commit("setLoading", true);
    commit("setSnackbar", false);
    axios
      .post(`https://backoffice.teller.ng/TellerAppManager/api/AirtimeVendRequest?customerID=${payload.customerID}&pin=${payload.pin}&network=${payload.network}&mobileNumber=${phoneNumber}&amountInCents=${payload.amount * 100}&imei='WEBSITE'`,{},{timeout:20000})
    .then(res => {
        console.log(res.data.message)
        if(res.data.message == 'OK'){
        commit("setSnackbar", true);
        commit("setServerMessage", "Successful")
        commit("setBalance",  res.data.updatedMainBalance );
        payload.route.push({name: "Successful"})
        commit("setCommissionBalance",  res.data.updatedCommissionBalance );
        commit("SetRouteName",  true );
        }else{
          commit("setSnackbar", true);
          commit("setServerMessage", res.data.message)
        } 
      })
      .catch(err => {
        console.log(err, 'err')
        if (err.code === 'ECONNABORTED'){
          commit("setSnackbar", true);
          commit("setServerMessage",  "Server Timeout" );
          return
        }
        commit("setServerMessage",  err.message );
      })
      .finally(()=>{
        commit("setLoading", false);
      })
  }, 

};

export default {
  state,
  mutations,
  getters,
  actions
};
